// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N100, N20, N50, N800 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var TooltipContent = styled.div({
  fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var OptionListItem = styled.li({
  cursor: 'pointer',
  padding: "var(--ds-space-075, 6px)".concat(" ", "var(--ds-space-100, 8px)"),
  fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: '24px'
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref) {
  var isSelected = _ref.isSelected;
  return isSelected && {
    background: "var(--ds-background-neutral-subtle-hovered, ".concat(N20, ")")
  };
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref2) {
  var isDeprecated = _ref2.isDeprecated;
  return isDeprecated && {
    cursor: 'default',
    color: "var(--ds-text-disabled, ".concat(N50, ")")
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var OptionName = styled.div({
  color: "var(--ds-text, ".concat(N800, ")"),
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  // Added so that overflowed option names do not squish the deprecated info icon
  flex: 1
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var DeprecatedOptionContainer = styled.div({
  color: "var(--ds-text-disabled, ".concat(N50, ")"),
  display: 'flex',
  justifyContent: 'space-between',
  opacity: 0.6
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var OptionHighlight = styled.span({
  fontWeight: "var(--ds-font-weight-bold, 700)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var FieldType = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginTop: "var(--ds-space-negative-025, -2px)",
  color: "var(--ds-text-subtlest, ".concat(N100, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var FieldTypeIcon = styled.span({
  display: 'flex',
  marginRight: "var(--ds-space-050, 4px)"
});